import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { NotificationViewerBarComponent } from './widgets/notification-viewer/notification-viewer-bar/notification-viewer-bar.component';
import { NotificationViewerItemComponent } from './widgets/notification-viewer/notification-viewer-item/notification-viewer-item.component';
import { NotificationViewerComponent } from './widgets/notification-viewer/notification-viewer.component';
import { NotificationViewerTableData } from './widgets/notification-viewer/notification-viewer.component.table';

@NgModule({
  declarations: [NotificationViewerComponent, NotificationViewerItemComponent, NotificationViewerBarComponent],
  imports: [SharedModule],
  exports: [NotificationViewerComponent],
  providers: [NotificationViewerTableData]
})
export class NotificationModule {}
